import { axiosInstance } from '../Middleware'
import { DotationEsag } from './types'

export class DotationApi {  
      public static loadConges = (complement?: string, silent?: boolean): Promise<DotationEsag> => {
          let url = '/personnel/personnel/sconges/dotationEsag';
      
          if (complement) {     
            url += complement;
          }
          return axiosInstance.get(url, silent ? { silent: true } as any : undefined)
            .then(response => response.data);
        }

         public static loadQuotas = (complement?: string, silent?: boolean): Promise<DotationEsag> => {
          let url = '/personnel/personnel/squotas/dotationEsag';
      
          if (complement) {     
            url += complement;
          }
          return axiosInstance.get(url, silent ? { silent: true } as any : undefined)
            .then(response => response.data);
        }
}
